import { useState } from "react";
import LoadingSpinner from "../../../Layout/components/LoadingSpinner";
import { Button, Grid, InputLabel, OutlinedInput, Stack } from "@mui/material";
import AnimateButton from "../../../Layout/components/@extended/AnimateButton";
import axios from "axios";

const ReceivableAccountForm = ({
  setReceivableAccount,
  fetchReceivableAccounts,
  editingAccount,
}) => {
  console.log(editingAccount);
  const [vendorName, setVendorName] = useState(
    editingAccount ? editingAccount.vendor_name : ""
  );

  const [accountNumber, setAccountNumber] = useState(
    editingAccount ? editingAccount.receivable_account_number : ""
  );

  const [submitting, setSubmitting] = useState(false);

  // Handle file upload

  const onSubmit = async () => {
    setSubmitting(true);
    const formData = {
      vendorName: vendorName,

      accountNumber: accountNumber,
    };

    try {
      if (editingAccount) {
        // Update the receivable account if editingAccount is provided
        await axios.post(
          `/manualPayment/updateReceivableAccount/${editingAccount.receivable_account_id}`,
          formData
        );
      } else {
        // Add a new receivable account if editingAccount is not provided
        await axios.post("/manualPayment/addReceivableAccount", formData);
      }
      fetchReceivableAccounts(); // Refresh the list of receivable accounts
      setReceivableAccount(false); // Close the modal
    } catch (error) {
      console.error("Error:", error);
      alert("Failed to save receivable account.");
    }
  };
  // Handler to allow only numeric values and limit to 4 digits
  const handleAccountNumberChange = (e) => {
    // Only allow numbers and limit input to 4 characters
    const value = e.target.value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
    if (value.length <= 4) {
      setAccountNumber(value);
    }
  };

  return (
    <LoadingSpinner isActive={submitting}>
      <Grid item xs={12} md={12}>
        <Stack spacing={1}>
          <InputLabel>Account Owner Name</InputLabel>
          <OutlinedInput
            required
            name="vendorName"
            id="vendorName"
            type="text"
            value={vendorName}
            onChange={(e) => setVendorName(e.target.value)}
            placeholder="Vendor Name"
          />
        </Stack>
      </Grid>

      <Grid item xs={12} md={12}>
        <Stack spacing={1}>
          <InputLabel>Account number(Last 4 digits)</InputLabel>
          <OutlinedInput
            required
            name="accountNumber"
            id="accountNumber"
            type="text"
            value={accountNumber}
            onChange={handleAccountNumberChange}
            placeholder="Last 4 digits"
          />
        </Stack>
      </Grid>

      <Grid item xs={12} marginTop={"2rem"}>
        <AnimateButton>
          <Stack direction={"row"} justifyContent={"right"} spacing={2}>
            <Button
              disableElevation
              size="sm"
              variant="outlined"
              color="secondary"
              onClick={() => setReceivableAccount(false)}
            >
              Cancel
            </Button>
            <Button
              disableElevation
              size="sm"
              variant="contained"
              color="primary"
              onClick={() => onSubmit()}
            >
              {editingAccount ? "Update" : "Add"}
            </Button>
          </Stack>
        </AnimateButton>
      </Grid>
    </LoadingSpinner>
  );
};

export default ReceivableAccountForm;
